import { ChainIdEnum } from "../../../enums/chain";
import { ChainConfig } from "../types";
import { DEFAULT_TOKEN_DECIMALS, MARGINX_BRANDING } from "./shared";

// ============================================
// ARBITRUM TESTNET (Chain ID: 421614)
// ============================================
export const arbitrumTestnetConfig: ChainConfig = {
  chainId: ChainIdEnum.ARBITRUM_TESTNET,
  name: "Arbitrum Sepolia Testnet",
  shortName: "arb-sepolia",
  isTestnet: true,
  rpcUrls: ["https://sepolia-rollup.arbitrum.io/rpc"],
  explorerUrl: "https://sepolia.arbiscan.io",
  l2ExplorerUrl: "https://basecamp.cloud.blockscout.com",
  nativeCurrency: { name: "Ether", symbol: "ETH", decimals: 18 },
  tokenDecimals: DEFAULT_TOKEN_DECIMALS,
  contracts: {
    erc20: {
      usdc: "0x8537307810fC40F4073A12a38554D4Ff78EfFf41",
      "usdc-native": "0x8537307810fC40F4073A12a38554D4Ff78EfFf41",
      usdt: "",
      weth: "0x8537307810fC40F4073A12a38554D4Ff78EfFf41",
      wbtc: "",
      l2usdc: "0x52623B37Ff81c53567D6D16fd94638734cCDCf27",
      l2usdt: "",
      l2weth: "0x80626896A2ad4a8ba69a93C4a519C23be26dD403",
      l2wbtc: "",
      govToken: "",
    },
    multichain: {
      socketHelper: "0x09F62d9f9fe489c2CD460D7Be8E78d4ACE0a8e60",
      vault: {
        usdc: "0xc317144DE60E6bC9455363bB09852C00bd14CD61",
        "native-usdc": "0xc317144DE60E6bC9455363bB09852C00bd14CD61",
        weth: "0xd286595d2e3D879596FAB51f83A702D10a6db27b",
      },
      connector: {
        usdc: "0xbDf50eAe568ECef74796ed6022a0d453e8432410",
        "native-usdc": "0xbDf50eAe568ECef74796ed6022a0d453e8432410",
        weth: "0xA7649aa944b7Dce781859C18913c2Dc8A97f03e4",
      },
      withdrawalConnector: {
        usdc: "0x7050b6f947BA48508219Ac02EC152E9f198ADc5e",
        "native-usdc": "0x7050b6f947BA48508219Ac02EC152E9f198ADc5e",
        weth: "0xA7f7e4fE8E4cdDCD9969Bd3fbcFF67000CD7DE47",
      },
      l2WithdrawProxy: "0x80bd95726009997A36d29A8e2Ba71B1a996F8E04",
    },
  },
  signingDomain: { name: "MarginX Arbitrum Testnet", version: "1" },
  socketL2ChainId: 11155112,
  branding: MARGINX_BRANDING,
};
